const currencySymbols: Record<string, string> = { EUR: "€", USD: "$" }

// Design format: €189 420.45 — space grouping, dot decimals. Credit notes: -€55.00
export const formatAmount = (amount: string, currency?: string) => {
  const value = Number(amount)
  const sign = value < 0 ? "-" : ""
  const symbol = currency ? (currencySymbols[currency] ?? `${currency} `) : ""
  const digits = Math.abs(value)
    .toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .replaceAll(",", " ")
  return `${sign}${symbol}${digits}`
}

// EUR first — it is the primary reporting currency
export const sortTotals = <T extends { currency: string }>(totals: T[]) =>
  totals.toSorted((a, b) => (a.currency === "EUR" ? -1 : b.currency === "EUR" ? 1 : 0))
